module.exports = __webpack_public_path__ + "img/eai.f380bcb9.png";